module.exports = __webpack_public_path__ + "img/7.541f27f9.png";